const MAX_RECORD_SIZE = 10_000
const MAX_DEPTH = 6
const CUT = '…'

type Budget = { left: number }

function capValue(value: unknown, budget: Budget, depth: number): unknown {
    budget.left -= 1
    if (typeof value === 'string') {
        if (value.length <= budget.left) {
            budget.left -= value.length
            return value
        }
        const kept = value.slice(0, Math.max(budget.left, 0))
        budget.left = 0
        return `${kept}${CUT} (${value.length} chars)`
    }
    if (!value || typeof value !== 'object') {
        return value
    }
    if (depth === MAX_DEPTH) {
        return CUT
    }
    if (Array.isArray(value)) {
        const items: unknown[] = []
        for (const item of value) {
            if (budget.left <= 0) {
                items.push(CUT)
                break
            }
            items.push(capValue(item, budget, depth + 1))
        }
        return items
    }
    return capFields(value, budget, depth)
}

function capFields(value: object, budget: Budget, depth: number): Record<string, unknown> {
    const fields: Record<string, unknown> = {}
    for (const [key, field] of Object.entries(value)) {
        if (budget.left <= 0) {
            fields[CUT] = CUT
            break
        }
        fields[key] = capValue(field, budget, depth + 1)
    }
    return fields
}

// The recorder runs for every visitor, so a record keeps a bounded copy of its data, not a game save or an ad's markup
export function capRecordData(data: object): Record<string, unknown> {
    return capFields(data, { left: MAX_RECORD_SIZE }, 0)
}
